export const locale = {
    'OFFER': {
        'STATUS': {
            'NOTACCEPTED': 'Не принят',
            'IN_QUEUE': 'В очереди',
            'DECLINED': 'Отказался',
        },
    },
}
